export const MININUM_ZOOM: number = 0.5
export const MAX_ZOOM: number = 2
